import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import React from "react";

type MarqueeProps = {
  items: React.ReactNode[];
};

const Marquee: React.FC<MarqueeProps> = ({ items }) => {
  const marqueeRef = React.useRef<HTMLDivElement>(null);
  const [duration, setDuration] = React.useState(0);
  const duplicatedItems = [...items, ...items];

  React.useEffect(() => {
    const marqueeWidth = marqueeRef.current ? marqueeRef.current.scrollWidth / 2 : 0;
    const speed = 50;
    setDuration(marqueeWidth / speed);
  }, [items]);

  return (
    <MarqueeRoot>
      <MarqueeAnimate ref={marqueeRef} duration={duration}>
        {duplicatedItems.map((item, index) => (
          <React.Fragment key={index}>{item}</React.Fragment>
        ))}
      </MarqueeAnimate>
    </MarqueeRoot>
  );
};

const MarqueeRoot = styled.div`
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  padding: 6px 0;
`;

const marquee = keyframes`
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-50%);
  }
`;

const MarqueeAnimate = styled.div<{ duration: number }>`
  display: flex;
  gap: 8px;
  animation: ${marquee} ${(props) => props.duration}s linear infinite;
  width: max-content;
`;

export default Marquee;
